import { useTranslation } from 'react-i18next';
import type { AgentProposalDto } from '@immoaktas/shared';
import type { ProposalView } from '../registry';

/** The text a tenant will read (message or reply to a report), with its line breaks, as a preview above the actions. */
export function messageText(p: Pick<AgentProposalDto, 'fields'>): string | null {
  const f = p.fields.find((x) => x.type === 'text' && /^s\d+\.text$/.test(x.key));
  return typeof f?.value === 'string' && f.value.trim() ? f.value : null;
}

function MessagePreview({ p }: { p: AgentProposalDto }) {
  const { t } = useTranslation();
  const text = messageText(p);
  if (!text) return null;
  return (
    <figure className="agent-message-preview" style={{ margin: '8px 0 0' }}>
      <figcaption className="secondary-text" style={{ fontSize: 12 }}>{t('agent.proposal.messagePreview')}</figcaption>
      <blockquote style={{ margin: '4px 0 0', padding: '8px 12px', borderLeft: '3px solid var(--ia-color-border-default)', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{text}</blockquote>
    </figure>
  );
}

export const view: ProposalView = { tools: ['propose_message_to_tenant', 'propose_report_status'], Details: MessagePreview };
